export const BUILD_VERSION = '1793896197';
